import {TextInput} from '@/components/atoms'
import {PageContainer} from '@/components/organisms'

const TaxesEdit = ({handleTaxInputChange, taxFields, errors}) => {
  return (
    <PageContainer data-testid="product-edit-brand-content">
      <div className="">
        <div className="">
          <div className="heading mt-[10px] text-base font-bold">Taxes</div>
          <div>
            {taxFields && taxFields.length > 0 && (
              taxFields
                .filter(field => !field.languages)
                .map((field, index) => (
                  <div key={`tax-field-${index}`}>
                    <div className="mt-3 grid grid-cols-4 gap-4 pb-5">
                      <TextInput
                        className="text-sm"
                        isDark={true}
                        label={'Tax Type Code'}
                        placeholderText={'Add Tax Type Code'}
                        value={taxFields?.[index]?.taxTypeCode ?? ''}
                        error={errors?.[field.key]}
                        onChange={value => {
                          handleTaxInputChange(index, 'taxTypeCode', value)
                        }}
                        disabled={true}
                      />
                      <TextInput
                        className="text-sm"
                        isDark={true}
                        label={'Tax Country Code'}
                        placeholderText={'Add Tax Country Code'}
                        value={taxFields?.[index]?.taxCountryCode ?? ''}
                        error={errors?.[field.key]}
                        disabled={true}
                        onChange={value => {
                          handleTaxInputChange(index, 'taxCountryCode', value)
                        }}
                      />
                      <TextInput
                        className="text-sm"
                        isDark={true}
                        label={'Tax Code'}
                        placeholderText={'Add Tax Code'}
                        disabled={true}
                        value={taxFields?.[index]?.taxCode ?? ''}
                        error={errors?.[field.key]}
                        onChange={value => {
                          handleTaxInputChange(index, 'taxCode', value)
                        }}
                      />
                      <TextInput
                        className="text-sm"
                        isDark={true}
                        label={'Tax Name'}
                        placeholderText={'Add Tax Name'}
                        disabled={true}
                        value={taxFields?.[index]?.taxName ?? ''}
                        error={errors?.[field.key]}
                        onChange={value => {
                          handleTaxInputChange(index, 'taxName', value)
                        }}
                      />
                    </div>
                  </div>
                ))
            )}
          </div>
        </div>
      </div>
    </PageContainer>
  )
}

export default TaxesEdit
